<template>
	<footer class="footer">
		<div class="footer-line">
			© {{legalCompanyName}} | All Rights Reserved | 
			<router-link to="/legal/privacy-policy">Privacy Policy</router-link> | 
			<router-link to="/legal/terms-of-use">Terms of Use</router-link> | 
			<router-link to="/legal/licensing" target="_blank">Licensing</router-link>
		</div>
	</footer>
</template>


<script>
	import AppConfig from '@/config';

	export default {
        name: 'public-footer',
        data() {
            return {
				legalCompanyName: AppConfig.brand.legalCompanyName,
            };
		}
	};
</script>


<style lang="scss" scoped>
@import '~@/assets/styles/references';

/* Footer/Copyright
**********************************/
.footer { text-align: center; font-size: $font-size-xs; color: color(black, hint); padding: gx(0.5) 0; }
.footer-line { margin-bottom: gx(0.5);
	a { color: inherit; white-space: nowrap; }
}
</style>
